import GeneralConditionedList from '../components/condicionados/GeneralConditionedList';
import PolicyList from '../components/policies/PolicyList';
import CreditPolicyList from '../components/credits/CreditPolicyList';
import ProjectList from '../components/projectComponents/ProjectList';
import isUserHasProfile from './profileValidator';
import { POLICY_READ, GENERAL_CONDITIONED_READ, EXTERNO_VV } from './profilePermission';

const getUserHome = (user) => {
  if (user.is_orsan) {
    if (isUserHasProfile(GENERAL_CONDITIONED_READ)) {
      return { path: '/condicionados', component: GeneralConditionedList };
    }

    if (isUserHasProfile(POLICY_READ)) {
      return { path: '/guarantee/policies', component: PolicyList };
    }

    return { path: '/credit/policies', component: CreditPolicyList };
  }
  if (isUserHasProfile(EXTERNO_VV)) {
    return { path: '/garantia/proyectos', component: ProjectList };
  }

  return { path: '/', component: undefined };
};

export default getUserHome;
